<template>
  <div class="dashboard">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="margin-right: 20px">当月数据</span>
        <el-date-picker
          @change="getBoard"
          v-model="yearMonth"
          type="month"
          format="yyyy-MM"
          value-format="yyyy-MM"
          placeholder="选择月"
        >
        </el-date-picker>
      </div>
      <panel-group :info="monthInfo" :isHome="true"/>
    </el-card>
    <el-card class="box-card" style="margin-top: 10px">
      <div slot="header" class="clearfix">
        <span>累计数据（所有数据）</span>
      </div>
      <panel-group :info="info" :isHome="true"/>
    </el-card>
  </div>
</template>

<script>
import PanelGroup from "./components/PanelGroup";
import { getBoard } from "@/api/chain/board";
import moment from "moment";
export default {
  name: "databoard",
  components: {
    PanelGroup,
  },
  data() {
    return {
      info: {},
      monthInfo: {},
      // options: [],
      // time: "",
      yearMonth: "",
    };
  },
  computed: {},
  watch: {},
  created() {
    document.documentElement.style.fontSize = "16px";
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    this.yearMonth = year.toString() + "-" + month.toString();
    // this.options = Array.apply(0, Array(12)).map(function(_,i){return year.toString() +'-'+(i<9?'0'+(i+1):i+1)})
    this.getBoard(this.yearMonth);
  },
  methods: {
    getBoard(yearMonth) {
      console.log(yearMonth);
      getBoard({ yearMonth }).then((res) => {
        console.log(res);
        this.info = res.data.data;
        this.monthInfo = {
          totalProject: res.data.data.currentProject || 0,
          totalWaybill: res.data.data.currentWaybill || 0,
          totalGarbage: res.data.data.currentGarbage || 0,
          totalUnpaid: res.data.data.currentUnpaid || 0,
          totalPaid: res.data.data.currentPaid || 0,
        };
      });
    },
  },
};
</script>

<style lang="scss">
.dashboard {
  padding: 0px 10px;
  .el-card__body {
    background-color: #f5f5f5;
    padding: 20px 20px 10px;
  }
}
</style>
